import { AEMCampaignId, CommonPERequest } from '../models';

export const AemCampaignIdMock: AEMCampaignId = {
  banner: 'ng-skymiles:amex-banners',
  format: 'json',
  micromoments: 'ng-skymiles:micro-moments-v1',
  offers: 'ng-skymiles:promotional-cards',
  partners: 'ng-skymiles:partners'
};

export const CommonPERequestMock: CommonPERequest = {
  micromomentCampaignId: 'ng-skymiles:micro-moments-v1',
  bannerCampaignId: 'ng-skymiles:amex-banners',
  offerCampaignId: 'ng-skymiles:promotional-cards',
  membershipLevel: 'DM',
  birthDay: false,
  sevenDaysBeforeBirthday: false,
  sevenDaysAfterBirthday: false,
  skyMilesAnniversary: false,
  ageRestrict: 'Y',
  format: 'json',
  amexCardMember: 'Y',
  newJoiner: false,
  profileSetUp: false,
  currentDate: '2024-01-10',
  skyclub: true
};
